import {
  Box,
  Card,
  Grid,
  Stack,
  Typography,
  LinearProgress,
  Divider,
  Button,
  List,
  Chip,
  ListItem,
  ListItemText,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import EmailIcon from '@mui/icons-material/Email';
import DateRangeIcon from '@mui/icons-material/DateRange';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import BadgeIcon from '@mui/icons-material/Badge';
import BuildIcon from '@mui/icons-material/Build';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DescriptionIcon from '@mui/icons-material/Description';
import AddCardIcon from '@mui/icons-material/AddCard';
import SecurityIcon from '@mui/icons-material/Security';
import PaymentIcon from '@mui/icons-material/Payment';
import HistoryIcon from '@mui/icons-material/History';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState, useCallback } from 'react';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import { useDispatch } from 'react-redux';
import CustomDialog from '../../components/CustomDialogue';
import {
  getProfileList,
  getSummaryList,
  getPaymentMethod,
  createPaymentMethod,
  updatePaymentMethod,
  getPaymentTypes
} from '../../store/Slice/Payout/PayoutSlice';
import usePayoutSelector from '../../store/Slice/Payout/PayoutSelector';
import { getLoginData } from '../../store/Slice/Login/LoginSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { fDate } from '../../utils/formatTime';
import Label from '../../components/Label';
import { PreviewImageApi } from '../../store/Slice/Global/GlobalSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Profile() {
  const [targets, setTargets] = useState({
    monthly: { target: 5000000, achieved: 3500000 },
    quarterly: { target: 15000000, achieved: 10500000 },
    yearly: { target: 60000000, achieved: 42000000 }
  });
  const [HistoryPopup, setHistoryPopup] = useState(false);
  const dispatch = useDispatch();

  const { LoginData } = useLoginSelector();
  const { PayoutProfileData, PaymentMethodData, PaymentTypesData } = usePayoutSelector();

  const [paymentForm, setPaymentForm] = useState({
    paymentType: 'BANK_TRANSFER',
    accountNumber: '',
    ifscCode: '',
    accountHolderName: '',
    upiId: '',
    paymentMethodId: null
  });

  const [isEdit, setIsEdit] = useState(false);

  // console.log('PayoutProfileData', PayoutProfileData);

  const advanceRequests = PayoutProfileData;

  const pct = (achieved, target) => {
    if (target === 0) return 0;
    return Math.round((achieved / target) * 100);
  };

  const [openPreview, setOpenPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [previewFileType, setPreviewFileType] = useState('image');
  const [pageNumber, setPageNumber] = useState(1);

  const handlePreviewDoc = async (doc) => {
    // alert('hiiii');
    const blob = await dispatch(PreviewImageApi(doc?.documentUrl, null, true));

    if (!blob) {
      console.error('No blob returned from PreviewImageApi');
      return;
    }

    setPreviewFileType(blob.type === 'application/pdf' ? 'pdf' : 'image');
    const fileURL = URL.createObjectURL(blob);
    setPreviewUrl(fileURL);
    setOpenPreview(true);
  };

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setPageNumber(1);
  }, []);

  const handleResetZoom = () => {
    setZoomLevel(1);
  };

  const handleDoubleClick = () => {
    if (zoomLevel === 1) {
      setZoomLevel(2);
    } else {
      setZoomLevel(1);
    }
  };

  const getProfileFileList = async () => {
    const credentials = {
      userId: LoginData?.userId
    };
    const result = await dispatch(getProfileList(credentials));
    console.log(result);
  };

  useEffect(() => {
    getProfileFileList();
    if (LoginData?.userId) {
      dispatch(getPaymentMethod(LoginData.userId));
      dispatch(getPaymentTypes());
    }
  }, [LoginData?.userId]);

  const handleOpenPaymentDialog = (edit = false) => {
    if (edit && PaymentMethodData) {
      setPaymentForm({
        paymentType: PaymentMethodData.paymentType || 'BANK_TRANSFER',
        accountNumber: PaymentMethodData.accountNumber || '',
        ifscCode: PaymentMethodData.ifscCode || '',
        accountHolderName: PaymentMethodData.accountHolderName || '',
        upiId: PaymentMethodData.upiId || '',
        paymentMethodId: PaymentMethodData.paymentMethodId
      });
      setIsEdit(true);
    } else {
      setPaymentForm({
        paymentType: 'BANK_TRANSFER',
        accountNumber: '',
        ifscCode: '',
        accountHolderName: '',
        upiId: '',
        paymentMethodId: null
      });
      setIsEdit(false);
    }
    setHistoryPopup(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSavePaymentMethod = async () => {
    const payload = {
      ...paymentForm,
      userId: LoginData?.userId
    };

    let res;
    if (isEdit) {
      res = await dispatch(updatePaymentMethod(payload));
    } else {
      res = await dispatch(createPaymentMethod(payload));
    }

    if (res) {
      setHistoryPopup(false);
      dispatch(getPaymentMethod(LoginData?.userId));
    }
  };

  const handleHistoryClick = async () => {
    setHistoryPopup(true);
    // Implement history functionality here, e.g., navigate to history page or open history dialog
  };

  const handleCloseHistoryDialog = () => {
    setHistoryPopup(false);
  };

  return (
    <Box sx={{ px: 2 }}>
      <Grid container spacing={3} height="100%">
        {/* -------- SUMMARY CARDS -------- */}

        <Grid item xs={12} md={4}>
          <Typography
            style={{ marginTop: '30px' }}
            variant="body1"
            className="headingLineUp headingLineUpOut"
          >
            Personal Details
          </Typography>

          <Box className="viewLeadCard cardTopMinusMargin" minHeight={450} mt={5} mb={3}>
            <Grid container spacing={{ xs: 1, sm: 2, md: 2 }} marginBottom={3}>
              <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={12}>
                <Box className="displayFlex">
                  <EmailIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Email</Typography>
                    <Typography className="labelText">{PayoutProfileData?.user?.email}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={12}>
                <Box className="displayFlex">
                  <DateRangeIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Joining Date</Typography>
                    <Typography className="labelText">
                      {PayoutProfileData?.accountOverview?.userjoiningDate}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={12}>
                <Box className="displayFlex">
                  <PersonIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Manager Name</Typography>
                    <Typography className="labelText">
                      {PayoutProfileData?.user?.managerName}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={12}>
                <Box className="displayFlex">
                  <PhoneIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Mobile</Typography>
                    <Typography className="labelText">{PayoutProfileData?.user?.mobile}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={12}>
                <Box className="displayFlex">
                  <BadgeIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Sales Manager Name</Typography>
                    <Typography className="labelText">
                      {PayoutProfileData?.user?.salesManagerName}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={12}>
                <Box className="displayFlex">
                  <BadgeIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">User ID</Typography>
                    <Typography className="labelText">{PayoutProfileData?.user?.userId}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={12}>
                <Box className="displayFlex">
                  <PersonIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">User Type</Typography>
                    <Typography className="labelText">
                      {PayoutProfileData?.user?.userType}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <Typography
              style={{ marginTop: '30px' }}
              variant="body1"
              className="headingLineUp headingLineUpOut"
            >
              Documents
            </Typography>

            <Box className="viewLeadCard cardTopMinusMargin" minHeight={450} mt={5} mb={3}>
              <Grid container marginBottom={3}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%'
                  }}
                >
                  <Stack spacing={2}>
                    {PayoutProfileData?.documents?.map((title) => (
                      <Box
                        key={title}
                        sx={{
                          p: 2,
                          border: '1px solid #e5e7eb',
                          borderRadius: 1,
                          bgcolor: 'background.paper'
                        }}
                      >
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <DescriptionIcon fontSize="small" />
                            <Typography
                              sx={{
                                fontFamily: '"Poppins", sans-serif',
                                fontSize: 13,
                                fontWeight: 600
                              }}
                            >
                              {title?.documentTypeCode}
                            </Typography>
                          </Stack>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Chip
                              label="Verified"
                              size="small"
                              sx={{
                                bgcolor: '#bbf7d0',
                                color: '#166534'
                              }}
                            />
                            <IconButton size="small" onClick={() => handlePreviewDoc(title)}>
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Stack>
                        </Stack>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              </Grid>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <Typography
              style={{ marginTop: '30px' }}
              variant="body1"
              className="headingLineUp headingLineUpOut"
            >
              Access Levels
            </Typography>

            <Box className="viewLeadCard cardTopMinusMargin" minHeight={450} mt={5} mb={3}>
              <Grid container marginBottom={3}>
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%'
                  }}
                >
                  <Stack spacing={2}>
                    <Box
                      sx={{
                        p: 2,
                        border: '1px solid #e5e7eb',
                        borderRadius: 1,
                        bgcolor: 'background.paper'
                      }}
                    >
                      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        <SecurityIcon />
                        <Typography
                          sx={{
                            fontFamily: '"Poppins", sans-serif',
                            fontSize: 13,
                            fontWeight: 600
                          }}
                        >
                          Portal Access
                        </Typography>
                      </Stack>
                      <Box>
                        {PayoutProfileData?.accessPages?.map((item) => (
                          <Chip
                            key={item?.pageId}
                            label={item?.pageName}
                            size="small"
                            sx={{
                              bgcolor: '#bbf7d0bc',
                              color: '#166534',
                              margin: '2px'
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  </Stack>
                </Box>
              </Grid>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <Typography
              // style={{ marginTop: '30px' }}
              variant="body1"
              className="headingLineUp headingLineUpOut"
            >
              Payment Details
            </Typography>

            <Box className="viewLeadCard cardTopMinusMargin" mt={5} mb={3}>
              <Grid container spacing={{ xs: 1, sm: 2, md: 2 }} marginBottom={3}>
                <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={12}>
                  <Box className="displayFlex">
                    <EmailIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Email</Typography>
                      <Typography className="labelText">
                        {PayoutProfileData?.user?.email}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ mb: '1' }} sm={6} md={12}>
                  <Box className="displayFlex">
                    <HistoryIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Last Payment Date</Typography>
                      <Typography className="labelText">
                        {PayoutProfileData?.paymentDetails?.lastPaymentDate}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                  <Box className="displayFlex">
                    <AccountBalanceWalletIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Total Advance Taken</Typography>
                      <Typography className="labelText">
                        {PayoutProfileData?.paymentDetails?.totalAdvanceTaken}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                  <Box className="displayFlex">
                    <PaymentIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Total Commission Earned</Typography>
                      <Typography className="labelText">
                        {PayoutProfileData?.paymentDetails?.totalCommissionEarned}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ pr: 3 }}
            >
              <Typography
                variant="body1"
                className="headingLineUp headingLineUpOut"
                sx={{
                  // mt: 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                {/* <PaymentIcon fontSize="small" /> */}
                Payment Method
              </Typography>
              {PaymentMethodData ? (
                <IconButton
                  sx={{ mt: 3, background: '#c4dfec', zIndex: 100 }}
                  color="primary"
                  onClick={() => handleOpenPaymentDialog(true)}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              ) : (
                ''
              )}
            </Stack>

            <Box className="viewLeadCard cardTopMinusMargin" mt={5} mb={3}>
              {PaymentMethodData ? (
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Paper
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        background: 'linear-gradient(135deg, #4fbbc8 0%, #d8f2f5 100%)',
                        color: 'white',
                        position: 'relative',
                        overflow: 'hidden',
                        minHeight: 180,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                      }}
                    >
                      <Box>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography variant="subtitle2" sx={{ opacity: 0.8, fontWeight: 500 }}>
                            {PaymentMethodData.paymentType === 'BANKTRANSFER' ||
                            PaymentMethodData.paymentType === 'BANK_TRANSFER' ||
                            PaymentMethodData.paymentType === 'NEFT' ||
                            PaymentMethodData.paymentType === 'RTGS' ||
                            PaymentMethodData.paymentType === 'IMPS'
                              ? 'BANK ACCOUNT'
                              : 'UPI ID'}
                          </Typography>
                          <PaymentIcon sx={{ opacity: 0.6 }} />
                        </Stack>
                        <Typography variant="h6" sx={{ mt: 1, letterSpacing: 0.5 }}>
                          {PaymentMethodData.accountHolderName}
                        </Typography>
                      </Box>

                      <Box>
                        {PaymentMethodData.paymentType === 'BANKTRANSFER' ||
                        PaymentMethodData.paymentType === 'BANK_TRANSFER' ||
                        PaymentMethodData.paymentType === 'NEFT' ||
                        PaymentMethodData.paymentType === 'RTGS' ||
                        PaymentMethodData.paymentType === 'IMPS' ? (
                          <>
                            <Typography variant="h5" sx={{ letterSpacing: 2, fontWeight: 600 }}>
                              {PaymentMethodData.accountNumber
                                ? `**** **** ${PaymentMethodData.accountNumber.slice(-4)}`
                                : '**** **** ****'}
                            </Typography>
                            <Typography variant="caption" sx={{ opacity: 0.7, mt: 0.5 }}>
                              IFSC: {PaymentMethodData.ifscCode}
                            </Typography>
                          </>
                        ) : (
                          <Typography variant="h6" sx={{ fontWeight: 500 }}>
                            {PaymentMethodData.upiId}
                          </Typography>
                        )}
                      </Box>

                      {/* Decorative elements */}
                      <Box
                        sx={{
                          position: 'absolute',
                          right: -30,
                          bottom: -30,
                          width: 120,
                          height: 120,
                          borderRadius: '50%',
                          background: 'rgba(255, 255, 255, 0.05)'
                        }}
                      />
                    </Paper>
                  </Grid>
                </Grid>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  py={2}
                  px={2}
                  sx={{
                    border: '2px dashed',
                    borderColor: 'divider',
                    borderRadius: 2,
                    bgcolor: 'action.hover'
                  }}
                >
                  <AddCardIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 3 }} />
                  <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
                    No Payment Method Found
                  </Typography>

                  <Button
                    variant="contained"
                    startIcon={<AddCardIcon />}
                    onClick={() => handleOpenPaymentDialog(false)}
                  >
                    Add Payment Method
                  </Button>
                </Box>
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* Document Preview Dialog */}
      <Dialog open={openPreview} onClose={() => setOpenPreview(false)} fullWidth maxWidth="md">
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6">Document Preview</Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOpenPreview(false)}
            sx={{
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <VisibilityIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'auto',
            bgcolor: '#f5f5f5',
            minHeight: '50vh'
          }}
        >
          {previewUrl && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              {previewFileType === 'pdf' ? (
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    p: 2,
                    borderRadius: 1,
                    overflow: 'auto',
                    maxHeight: '70vh'
                  }}
                >
                  <Document
                    file={previewUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<div>Loading PDF...</div>}
                  >
                    <Pages
                      pageNumber={pageNumber}
                      scale={zoomLevel}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Document>
                </Box>
              ) : (
                <Box
                  component="img"
                  src={previewUrl}
                  alt="Preview"
                  onDoubleClick={handleDoubleClick}
                  sx={{
                    width: '100%',
                    maxHeight: 500,
                    objectFit: 'contain',
                    transform: `scale(${zoomLevel})`,
                    transition: 'transform 0.3s ease-in-out',
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&:hover': {
                      cursor: 'zoom-in'
                    }
                  }}
                />
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleResetZoom} variant="outlined" size="small">
            Reset Zoom
          </Button>
          <Button
            onClick={() => {
              setOpenPreview(false);
              handleResetZoom();
            }}
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <CustomDialog
        showCloseIcon
        open={HistoryPopup}
        maxWidth="sm"
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseHistoryDialog();
          }
        }}
        title={isEdit ? 'Edit Payment Method' : 'Add Payment Method'}
        content={
          <Box p={2}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Payment Type"
                  name="paymentType"
                  value={paymentForm.paymentType}
                  onChange={handleInputChange}
                >
                  {PaymentTypesData && PaymentTypesData.length > 0 ? (
                    PaymentTypesData.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {type.replace('_', ' ')}
                      </MenuItem>
                    ))
                  ) : (
                    <>
                      <MenuItem value="BANK_TRANSFER">Bank Transfer</MenuItem>
                      <MenuItem value="UPI">UPI</MenuItem>
                    </>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Account Holder Name"
                  name="accountHolderName"
                  value={paymentForm.accountHolderName}
                  onChange={handleInputChange}
                />
              </Grid>

              {paymentForm.paymentType === 'BANKTRANSFER' ||
              paymentForm.paymentType === 'BANK_TRANSFER' ||
              paymentForm.paymentType === 'NEFT' ||
              paymentForm.paymentType === 'RTGS' ||
              paymentForm.paymentType === 'IMPS' ? (
                <>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Account Number"
                      name="accountNumber"
                      value={paymentForm.accountNumber}
                      onChange={handleInputChange}
                      placeholder="Enter account number"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="IFSC Code"
                      name="ifscCode"
                      value={paymentForm.ifscCode}
                      onChange={handleInputChange}
                      placeholder="Enter IFSC code"
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="UPI ID"
                    name="upiId"
                    value={paymentForm.upiId}
                    onChange={handleInputChange}
                    placeholder="example@upi"
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        }
        actions={
          <Box
            display="flex"
            justifyContent="flex-end"
            gap={2}
            p={2}
            sx={{ borderTop: 1, borderColor: 'divider' }}
          >
            <Button variant="outlined" color="inherit" onClick={handleCloseHistoryDialog}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSavePaymentMethod} sx={{ minWidth: 100 }}>
              {isEdit ? 'Update' : 'Save'}
            </Button>
          </Box>
        }
      />
    </Box>
  );
}

export default Profile;
